import { useCallback } from 'react';
import type { ItemSettingsDto, PanelSettingsDto } from '../../app/api/generated/client';
import { useLiquidityCashWithJbSettings, useLiquidityCashWithOtherBanksSettings } from '../api';

/** Sum of the enabled cash/short-term positions across the JB (internal) and other-banks (external) settings panels. */
export const useLiquiditySelectedBankableAssets = (): number => {
    const { data: internalAssets, isSuccess: isInternalAssetsSuccess } = useLiquidityCashWithJbSettings();
    const { data: externalAssets, isSuccess: isExternalAssetsSuccess } = useLiquidityCashWithOtherBanksSettings();

    const getSelectedAssets = useCallback(
        (assets?: PanelSettingsDto) => {
            if (!isInternalAssetsSuccess || !isExternalAssetsSuccess || !assets?.enabled) return 0;

            return assets.itemsSettings.filter((asset: ItemSettingsDto) => asset.enabled).reduce((total, asset: ItemSettingsDto) => total + asset.amount!, 0);
        },
        [isInternalAssetsSuccess, isExternalAssetsSuccess],
    );

    return getSelectedAssets(internalAssets) + getSelectedAssets(externalAssets);
};
